import React from 'react';
import { Tooltip } from 'antd';

export default class ProgressBar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const parent = this.props;
        const values = (parent.readings && parent.readings.length) && parent.readings.map((item, i) => {
            if (item.value > 0) {
                return (
                    <div className="value" style={{'color': '#65708D', 'width': item.value + '%'}} key={i}>
                        <span>{item.value}%</span>
                    </div>
                )
            }
        });

        const calibrations = (parent.readings && parent.readings.length) && parent.readings.map((item, i) => {
            if (item.value > 0) {
                return (
                    <div className="graduation" style={{'color': item.color, 'width': item.value + '%'}} key={i}>
                    </div>
                )
            }
        });

        const bars = (parent.readings && parent.readings.length) && parent.readings.map((item, i) => {
            if (item.value > 0) {
                return (
                    <Tooltip title={item.name === 'Not started' ? item.name : item.value+'%'}>
                        <div className="bar" style={{'background': item.color, 'width': item.value + '%'}} key={i}>
                        </div>
                    </Tooltip>
                )
            }
        });

        const legends = (parent.readings && parent.readings.length) && parent.readings.map((item, i) => {
            if (item.value > 0) {
                return (
                    <div className="legend" key={i}>
                        <span className="dot" style={{'color': item.color}}>●</span>
                        <span className="label">{item.name}</span>
                    </div>
                )
            }
        });

        return (
            <div className="multicolor-bar">
                <div className="scale">
                    {calibrations == '' ? '' : calibrations}
                </div>
                <div className="bars">
                    {bars == '' ? '' : bars}
                </div>
            </div>
        );
    }
}
